module.exports = {
      id: "pause-usage",
      viewBox: "0 0 31 30",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#pause",
      toString: function () {
        return this.url;
      }
    }